export const ADD_SUCCESS = 'ADD_SUCCESS';
export const REMOVE_SUCCESS = 'REMOVE_SUCCESS';
export const CLEAR_SUCCESSES = 'CLEAR_SUCCESSES';

export const clearSuccesses = () => ({
  type: CLEAR_SUCCESSES,
});

export const addSuccess = (success) => ({
  type: ADD_SUCCESS,
  code: success.code,
  message: success.message,
});

export const removeSuccess = (success) => ({
  type: REMOVE_SUCCESS,
  success,
});
